import { Field, Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';

const ResultsModal = ({showEditResultsModal, handleHideEditResultsModal, handleAddNewResult, order}) => {

    //create order shortcuts
    const originalResults = order.results;
    const orderDetails = order.details;

    //parse the specific details
    const investigationSpecificDetails = JSON.parse(orderDetails.specificOrderTypeDetails);

    //results verbage object for resultStatus Field select
    const resultsVerbage = {
        "Driver Not On Policy": "{Name} is not on the policy, nor are they excluded, thus covered under permissive use. Would you like us to locate and obtain the driver’s policy? Your invoice will be sent to you shortly. ",
        "Vehicle Not on Policy": "The vehicle is not on the policy. Would you like us to locate and obtain the vehicle’s policy? Your invoice will be sent to you shortly.",
        "Umbrella": "I noticed the insured has high enough coverages and may have an umbrella policy. Would you like us to attempt to locate and obtain the umbrella policy limits? We will amend the order type to an umbrella combo, which must be requested within two weeks to be honored. Unless otherwise specified, this search is for the current insurance company; if you would like us to search other insurance companies, an additional charge will apply. Your invoice will be sent to you shortly.",
        "Can't Confirm, No Charge": "Unfortunately, we are unable to confirm if the policy limits are consistent for the date of loss. You will not be charged for this order. Thank you for your order, and have a great day.",
        "Can't Confirm with No-Hit Fee": "Unfortunately, we are unable to confirm if the policy limits are consistent for the date of loss. You will only be charged the no-hit fee for this order. Thank you for your order, and have a great day.",
        "No Charge": "Unfortunately, we are unable to obtain the policy limits for {Name}. You will not be charged for this order. Thank you for your order, and have a great day.",
        "UTO with No-Hit Fee": "Unfortunately, we are unable to obtain the policy limits for {Name}. You will only be charged the no-hit fee for this order. Thank you for your order, and have a great day.",
        "Can’t Get": "Unfortunately, we are unable to obtain the policy limits for {Name}. Thank you for your order, and have a great day.",
        "Locate Only": "Do you want us to obtain the policy limits? Your invoice will be sent to you shortly.",
        "Can't Find and Obtain": "Unfortunately, we are unable to locate the insurance company and obtain the policy limits for {Name}. Thank you for your order, and have a great day.",
        "Can't Find Only": "Unfortunately, we are unable to locate the insurance company for {Name}. Thank you for your order, and have a great day.",
        "Can't Find with Possible Ins Co": "Unfortunately, we are unable to locate the insurance company and obtain the policy limits for {Name}. We believe the insurance is {Company}, but we cannot confirm. Thank you for your order, and have a great day.",
        "Impounded": "Unfortunately, we are unable to locate the insurance company and obtain the policy limits for {Name}. We do not believe there was insurance since the vehicle was impounded on the date of loss. Thank you for your order, and have a great day.",
        "Policy Does not Cover DOL": "The policy ended/cancelled/started {Date} and was not in force at the time of loss. Please let us know if you would like us to locate the active policy at the time of loss. Your invoice will be sent to you shortly.",
        "Closing Orders No Charge": "Please note that we are closing the order for {Name}. You will not be charged for this order. If you would like us to continue working on this order, please resubmit with all documentation as a new order. Thank you, and have a great day.",
        "Closing Orders with Charge": "Please note that we are closing the order for {Name}. If you would like us to continue working on this order, please resubmit with all documentation as a new order. Thank you, and have a great day.",
        "Rental Companies": "The policy limits below are for ***EAN Holdings***. We are unable to determine if the renter took the supplemental liability insurance offered by ***EAN Holdings***. Would you please let us know if you would like us to locate and obtain the renters personal auto policy? Your invoice will be sent to you shortly.",
    }

    // handle auto populating resultStatus into results when new status is changed, replacing dynamic fields with their matching data
    const handleSelectChange = (e, setFieldValue, values) => {
        const selectedValue = e.target.value;
        let selectedValueData = resultsVerbage[selectedValue];

        //outline words to populate dynamic data into for each investigation type 
        const highlightName = orderDetails.caseName || '***Name***';
        const highlightCompany = investigationSpecificDetails.driversInsuranceCompany || '***Company***';
        //Currently there is no policy date as part of intake so flagging date for user's review
        const highlightDate = '***Date***'

        //replace dynamic fields with their matching data
        selectedValueData = selectedValueData.replace('{Name}', highlightName);
        selectedValueData = selectedValueData.replace('{Company}', highlightCompany);
        selectedValueData = selectedValueData.replace('{Date}', highlightDate);

        //append the selected value to the current text in the results field everytime and set the dropdown value
        setFieldValue('results', `${values.results ? values.results + '\n\n' : ''}${selectedValueData}`);
        setFieldValue('resultStatus', `${selectedValue}`);
    };

    /**
     * setup the initial values 
     */
    const parsedOriginalResults = originalResults ? JSON.parse(originalResults) : '';

    const initialValues = {
        resultType: parsedOriginalResults.resultType || '',
        results: parsedOriginalResults.results || '',
        resultStatus: parsedOriginalResults.resultStatus || ''
    };

    return (
        <Modal
            backdrop="static"
            show={showEditResultsModal}
            onHide={handleHideEditResultsModal}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Edit Investigation Results</Modal.Title>
            </Modal.Header>

            <Formik
                initialValues={initialValues}
                onSubmit={handleAddNewResult}
            >
                {({ errors, dirty, isValid, touched, values, setFieldValue}) => (
                    <Form>
                        <Modal.Body>
                            <div className="form-wrapper">
                                <div className="form-row four-col-equal" role="group" aria-labelledby="radio-group">
                                    <div>
                                        <label className="left-justified" htmlFor="uto">UTO</label>
                                            <div className="form-check">
                                                <Field type="radio" name="resultType" value="UTO" id="uto" />
                                            </div>
                                    </div>
                                    <div>
                                        <label className="left-justified" htmlFor="utc">UTC</label>
                                            <div className="form-check">
                                                <Field type="radio" name="resultType" value="UTC" id="utc" />
                                            </div>
                                    </div>
                                    <div>
                                        <label className="left-justified" htmlFor="dnl">DNL</label>
                                            <div className="form-check">
                                                <Field type="radio" name="resultType" value="DNL" id="dnl"/>
                                            </div>
                                    </div>
                                    <div>
                                        <label className="left-justified" htmlFor="impounded">Impounded</label>
                                            <div className="form-check">
                                                <Field type="radio" name="resultType" value="Impounded" id="impounded"/>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        { (orderDetails.investigationType.includes('Insurance Investigation') || orderDetails.investigationType.includes('Insurance Claim History')) &&
                            <div className="form-field-wrapper mb-5 mt-0">
                                        <label htmlFor="resultStatus">Status <span className="required">*</span></label>
                                        <Field id="resultStatus" name="resultStatus" as="select" onChange={e => handleSelectChange(e, setFieldValue, values)}>
                                            <option value="" defaultValue disabled>Select a Result</option>
                                            <option value="Driver Not On Policy">Driver Not on Policy</option>
                                            <option value="Vehicle Not on Policy">Vehicle Not on Policy</option>
                                            <option value="Umbrella">Umbrella</option>
                                            <option value="Can't Confirm, No Charge">Can't Confirm, No Charge</option>
                                            <option value="Can't Confirm with No-Hit Fee">Can't Confirm with No-Hit Fee</option>
                                            <option value="No Charge">No Charge</option>
                                            <option value="UTO with No-Hit Fee">UTO with No-Hit Fee</option>
                                            <option value="Can't Get">Can't Get</option>
                                            <option value="Locate Only">Locate Only</option>
                                            <option value="Can't Find and Obtain">Can't Find and Obtain</option>
                                            <option value="Can't Find Only">Can't Find Only</option>
                                            <option value="Can't Find with Possible Ins Co">Can't Find with Possible Ins Co</option>
                                            <option value="Impounded">Impounded</option>
                                            <option value="Policy Does not Cover DOL">Policy Does not Cover DOL</option>
                                            <option value="Closing Orders No Charge">Closing Orders No Charge</option>
                                            <option value="Closing Orders with Charge">Closing Orders with Charge</option>
                                            <option value="Rental Companies">Rental Companies</option>
                                        </Field>
                            </div>
                        }
                            <div className="form-field-wrapper">
                                <Field as="textarea" rows="15" id="results" name="results"/>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <div className="investigation-results-container-left">
                                <button type="submit" disabled={!((dirty) && isValid)} className="button outlined investigation-results-save">Save</button>
                            </div>
                            <div className="investigation-results-container-right">
                                <button className="button outlined secondary investigation-results" type="button" onClick={handleHideEditResultsModal}>Cancel</button>
                            </div>
                            
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal >  
    );
};

export default ResultsModal;